// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F723i","importantInfo":"styles_importantInfo__1k5nK"};